import { UserNotificationInfo } from "common-util-experience-client";
import { formatPassTime } from "../helper/dateFormatter";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { UsersApi } from "users-experience-client";
import { createUsersApi } from "../api-helpers/UserApiHelper";
import { createTaskApi } from "../api-helpers/TaskApiHelper";
import no from "@mobiscroll/react/dist/src/i18n/no";
import { createPatientApi } from "../api-helpers/PatientApiHelper";
import { LoadingHelper } from "../components/loader/LoadingHelper";
import '../assets/scss/custom/priorityBadge.scss';
import { PriorityBadge } from "../renderers/PriorityBadge";

interface Props {
  notification: UserNotificationInfo;
  onDeleteClicked: () => void;
  onCloseModalTrigger: () => void;
}

interface NotificationDetail {
  patientName: string;
  type: string;
  detail: string;
  priority?: string;
}

const userApi: UsersApi = createUsersApi();
const taskApi = createTaskApi();
const patientApi = createPatientApi();

const TaskNotification = ({
  notification,
  onDeleteClicked,
  onCloseModalTrigger,
}: Props) => {
  const [initials, setInitials] = useState<string>();
  const [notificationDetail, setNotificationDetail] =
    useState<NotificationDetail | null>(null);

  useEffect(() => {
    if (!notification) {
      return;
    }
    LoadingHelper.showLoader(".notifications-list");
    const fetchNotificationDetails = async () => {
      try {
        await getNotificationDetails(notification);
      } catch (error) {
        console.error("Error fetching notification details:", error);
      } finally{
        LoadingHelper.hideLoader(".notifications-list");
      }
    };
    fetchNotificationDetails();
  }, [notification]);

  const createHttpLink = () => {
    switch (notification.refType.toLowerCase()) {
      case "task":
        return "/tasks?selectedId=" + notification.refIds;
      default:
        return "#";
    }
  };

  const getNotificationDetails =async (notification: UserNotificationInfo) => {
    switch (notification.refType.toLowerCase()) {
      case "task":
        return await getTaskNotificationDetails(notification);
      default:
        return "#";
    }
  };
  const getTaskNotificationDetails = async (
    notification: UserNotificationInfo
  ) => {
    const taskDetail = await taskApi.taskControllerFindOne(notification.refIds);

    const patientDetail = await patientApi.patientsControllerGetBasicInfo(
      taskDetail.data.patientId
    );

    const initials =
      patientDetail.data.firstName.substring(0, 1).toUpperCase() +
      (patientDetail.data.lastName?.substring(0, 1) ?? "");
    setInitials(initials);

    setNotificationDetail({
      ...notificationDetail,
      patientName:
        patientDetail.data.firstName + " " + patientDetail.data.lastName,
      type: "Task",
      detail: taskDetail.data.taskType,
      priority: taskDetail.data.priority,
    });
  };

  const handleClick = () => {
    switch (notification.refType.toLowerCase()) {
      case "task":
        onCloseModalTrigger();
        break;
    }
  };

  return (
    <Link
      className="d-flex p-1 py-2 notification-card border-bottom border-gray"
      to={createHttpLink()}
      onClick={handleClick}
    >
      <span className="d-block user-icon me-2">{initials}</span>

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: "600" }}>
            {notificationDetail?.patientName}
          </span>
          <span
            style={{
              fontSize: "14px",
              color: "#888",
              cursor: "pointer",
            }}
            onClick={onDeleteClicked}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "20px", verticalAlign: "top" }}
            >
              delete
            </span>
          </span>
        </div>

        <span style={{ fontSize: "13px", color: "#888" }}>
          {notificationDetail?.type}
        </span>

        <span style={{ fontSize: "13px" }}>{notificationDetail?.detail}</span>

        {notificationDetail?.priority && (
          <PriorityBadge params={notificationDetail.priority || "Loading..."} />
        )}

        <span
          style={{
            fontSize: "12px",
            color: "#888",
            marginTop: "4px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            className="material-symbols-outlined"
            style={{
              fontSize: "14px",
              verticalAlign: "top",
              marginRight: "4px",
            }}
          >
            schedule
          </span>
          {formatPassTime(notification.createdOn)} ago
        </span>
      </div>
    </Link>
  );
};

export default TaskNotification;
